(() => {

    gsap.registerPlugin(ScrollTrigger);

    // saveStyles : scrollTirgger로 pc에 적용된 값이 mo로 바뀌었을 때 영향을 주지 않기 위해 기존 스타일 값을 저장하는 매서드
    ScrollTrigger.saveStyles(
        '.sc-point__item--03 .img-wrap, .sc-point__item--03 .text-box, .sc-point__item--04, .sc-point__item--04 .img-box, .sc-point__item--04 .text-box'
    );

    ScrollTrigger.matchMedia({
        '(min-width: 751px)': () => {
            gsap.timeline({
                scrollTrigger: {
                    trigger: '.sc-point__item--03',
                    ease: 'none',
                    start: '0% 100%',
                    end: '100% 100%',
                    scrub: 2,
                    invalidateOnRefresh: true,
                },
            })
                .to('.sc-point__item--03 .img-wrap', { width: '100%', height: '100%' })
                .fromTo('.sc-point__item--03 .text-box', { yPercent: 15 }, { opacity: 1, yPercent: 0 }, '>-20%');
        },
        '(min-width: 751px) and (max-width: 1024px)': () => {
            gsap.fromTo(
                '.sc-point__item--04 .img-box',
                { scale: 0.5 },
                {
                    scale: 1,
                    scrollTrigger: {
                        trigger: '.sc-point__item--04 .img-wrap',
                        ease: 'none',
                        scrub: 2,
                        start: '0% 100%',
                        end: '100% 100%',
                        invalidateOnRefresh: true,
                    },
                }
            );
            gsap.fromTo(
                '.sc-point__item--04 .text-box',
                { yPercent: 10, opacity: 0 },
                {
                    yPercent: 0,
                    opacity: 1,
                    scrollTrigger: {
                        trigger: '.sc-point__item--04',
                        ease: 'none',
                        scrub: 2,
                        start: '70% bottom',
                        end: 'bottom bottom',
                        invalidateOnRefresh: true,
                    },
                }
            );
        },
        '(min-width: 1025px)': () => {
            gsap.timeline({
                scrollTrigger: {
                    trigger: '.sc-point__item--04',
                    ease: 'none',
                    scrub: 2,
                    start: 'top top',
                    end: 'bottom bottom',
                    invalidateOnRefresh: true,
                },
            })
                .fromTo('.sc-point__item--04 .img-box', { scale: 1.3468 }, { scale: 1 })
                .fromTo(
                    '.sc-point__item--04 .img-wrap',
                    {
                        xPercent: 38.76,
                        // 38.76 계산 -> 1920 기준 img-wrap의 width는 890이며, 중앙으로 오기 위해서는 50%에서 100px 덜 가야함. 890px의 100px은 11.24%, 50% - 11.24% = 38.76
                    },
                    { xPercent: 0, duration: 1.5 },
                    'a'
                )
                .fromTo(
                    '.sc-point__item--04 .text-box',
                    { xPercent: -50, opacity: 0 },
                    { xPercent: 0, opacity: 1, duration: 1.5 },
                    'a'
                );
        },
        all: () => {
            // 패럴랙스
            new setParallax('.sc-point__item--01 .img-wrap', '.sc-point__item--01 img', '-4%', '4%');
            new setParallax('.sc-point__item--02 .img-wrap', '.sc-point__item--02 img', '-10%', '10%');
            new setParallax('.sc-outro .img-wrap', '.sc-outro img', '-13%', '13%');
        },
    });
})();
